export default Object.freeze({
  Physical: 1,
  Postal: 2,
  Payments: 3,
});
